import React from 'react';
import { View, Text, StyleSheet, Link } from '@react-pdf/renderer';
import GeneralPageLayout from './GeneralPageLayout';
import PdfImageFromAzureWithOptions from '../../../atoms/PdfImageFromAzureWithOptions';

const CtaPage = ({
  primaryBrand,
  uuid
}): JSX.Element => {
  const Styles = StyleSheet.create({
    sectionHeader: {},
    pageStyles: {
      fontFamily: 'Helvetica',
      fontSize: 12,
      lineHeight: 1.14,
    },
    pageTitleView: {
      fontFamily: 'Times-Bold',
      fontSize: 28,
      lineHeight: 1.14,
      marginBottom: 14,
    },
    pageTitleEmphasis: {
      fontFamily: 'Times-BoldItalic',
    },
    blurbTitle: {
      fontFamily: 'Times-Roman',
      fontSize: 14,
    },
    blurbEmphasis: {
      fontFamily: 'Times-Italic',
      fontSize: 14,
      marginBottom: 7,
    },
    blurbImage: {
      marginBottom: 14,
    },
    blurbColumn: {
      width: '30%',
      fontFamily: 'Helvetica',
      fontSize: 12,
      lineHeight: 1.14,
    },
  });

  return (
    <GeneralPageLayout
      sectionTypeText="Next Steps"
      sectionTitleText=""
      textColor={primaryBrand.colors.dark}
      backgroundColor="white"
      footerText={uuid}
    >
      <View style={ Styles.pageStyles }>
        <View style={ Styles.pageTitleView }>
          <Text>
            Take the first step toward health equity today.
          </Text>
          <Text style={ Styles.pageTitleEmphasis }>
              Everyone will benefit tomorrow.
          </Text>
        </View>
        <View style={{ 
          marginBottom: 28,
         }}>
          <Text>
            With initiatives such as ACO REACH and the Enhanced Oncology Model, CMS emphasizes the importance of a robust SDOH and Health Equity strategy. Between 2023 and 2025, leading providers leveraging Lightbeam’s Health Equity offerings will benefit their communities and themselves.
          </Text>
          <Link style={{ marginTop: 7 }} src="https://lightbeamhealth.com/radian-demo/?utm_source=radian_pdf">
            <Text>Request a Demo of a Solution Below</Text>
          </Link>
          
        </View>
        <View style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          fontFamily: 'Helvetica',
          fontSize: 14,
          lineHeight: 1.14,
        }}>
          <View style={Styles.blurbColumn}>
            <Text style={ Styles.blurbTitle }>Analytics for</Text>
            <Text style={ Styles.blurbEmphasis }>ACO REACH and Health&nbsp;Equity</Text>
            <PdfImageFromAzureWithOptions
              fileName="lb-aco-reach.png"
              folderPath="assets/pdf_graphics/"
              style={ Styles.blurbImage }
            />
            <Text>
              Leverage HIE, EHR, Claims, ADT, and other data sources to provide the most accurate analytics for the communities you serve.
            </Text>
          </View>
          <View style={Styles.blurbColumn}>
            <Text style={ Styles.blurbTitle }>Deviceless RPM for</Text>
            <Text style={ Styles.blurbEmphasis }>Social Determinants of&nbsp;Health</Text>
            <PdfImageFromAzureWithOptions
              fileName="cs-sdoh.png"
              folderPath="assets/pdf_graphics/"
              style={ Styles.blurbImage }
            />
            <Text>
              Collect patient- or member-reported outcomes to track potential barriers to health equity so your LSW or Care Management teammates can reach out at the right time to help.
            </Text>
          </View>
          <View style={Styles.blurbColumn}>
            <Text style={ Styles.blurbTitle }>Health Equity AI for</Text>
            <Text style={ Styles.blurbEmphasis }>Individual-Level Health&nbsp;Equity</Text>
            <PdfImageFromAzureWithOptions
              fileName="jv-individual.png"
              folderPath="assets/pdf_graphics/"
              style={ Styles.blurbImage }
            />
            <Text>
              Employ patient- or member-specific predictive models to uncover risk factors and review prescriptive recommendations for everyone you serve.
            </Text>
          </View>
        </View>
      </View>
    </GeneralPageLayout>
  );
};

export default CtaPage;
